(() => {
  if (window.tcHeroTitleLoaded) return;
  window.tcHeroTitleLoaded = true;
  const instances = new Map();
  function init(root) {
    if (instances.has(root) || !root.querySelector('.tc-home-hero__gold')) return;
    const events = new AbortController();
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let timer = 0;
    function start() {
      clearTimeout(timer);
      root.classList.remove('tc-hero-shine-started');
      if (!motion.matches) {
        // Play once shortly after arrival, independently of scrolling.
        timer = setTimeout(() => {
          timer = 0;
          root.classList.add('tc-hero-shine-started');
        }, 1000);
      }
    }
    motion.addEventListener('change', start, {signal:events.signal});
    start();
    instances.set(root, () => { events.abort(); clearTimeout(timer); root.classList.remove('tc-hero-shine-started'); instances.delete(root); });
  }
  function scan(scope) { scope.querySelectorAll('.tc-home-hero').forEach(init); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => instances.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); }));
})();
